import { combineEpics } from 'redux-observable';
import {
  restoreCurrentLocationEpic,
  restoreSelectedVarsEpic,
  currentLocationChildrenEpic,
  currentLocationFloorplanEpic,
  fetchLocationFloorplanEpic,
  restoreSelectedPlotVarsEpic,
} from './location';
import {
  fetchLatestVarNameDataEpic,
  fetchSensorLatestDetailsEpic,
  selectedSensorsEpic,
  updateFilterDataEpic,
  updateActivePlotVarsEpic,
  storeSelectedVarsEpic,
} from './sensors';
import storeTempUserEpic from './userAuth';
import {
  storeActiveMarkerEpic,
  storeMotionThresholdEpic,
  storeSelectedHoursEpic,
  storeSortByEpic,
  storeShowHelpEpic,
  storeDashboardPanelEpic,
  storeThemeModeEpic,
  storePlotVarsEpic,
} from './ui';

export default combineEpics(
  currentLocationChildrenEpic,
  currentLocationFloorplanEpic,
  fetchLocationFloorplanEpic,
  restoreSelectedVarsEpic,
  restoreSelectedPlotVarsEpic,
  restoreCurrentLocationEpic,
  updateFilterDataEpic,
  fetchLatestVarNameDataEpic,
  fetchSensorLatestDetailsEpic,
  selectedSensorsEpic,
  updateActivePlotVarsEpic,
  storeSelectedVarsEpic,
  storeTempUserEpic,
  storeActiveMarkerEpic,
  storeMotionThresholdEpic,
  storeSelectedHoursEpic,
  storeSortByEpic,
  storeShowHelpEpic,
  storeDashboardPanelEpic,
  storeThemeModeEpic,
  storePlotVarsEpic
);
